/**
 * Fait : charge les chapitres de la notice et rend celui qu'on demande — le
 *   premier quand aucun n'est nommé. C'est la seule liste : le sommaire et la
 *   page lue s'en servent tous les deux, donc ils ne peuvent pas diverger.
 *
 * Ne fait pas : il ne contient aucun texte. Le contenu vit dans
 *   `notice.json`, et c'est délibéré — une notice est de la RÉDACTION, pas du
 *   code. L'y garder permet de la relire, la corriger et la traduire sans
 *   toucher à un fichier TypeScript, et lui évite les règles de tenue du code,
 *   qui coupent les lignes à 120 caractères et hacheraient les phrases.
 */

import type { ChapitreDeNotice } from './contrat.ts';
import contenu from './notice.json' with { type: 'json' };

/**
 * L'ordre est celui d'une première lecture : on comprend l'esprit, on entre,
 * on crée un espace, on l'ouvre aux autres, on travaille, puis on va vers ce
 * qui sert le travail. Les manques ferment la marche.
 */
export const CHAPITRES = contenu.chapitres as readonly ChapitreDeNotice[];

/** Le chapitre demandé, ou le premier — jamais rien. */
export function chapitrePourId(id: string | null): ChapitreDeNotice {
  return CHAPITRES.find((chapitre) => chapitre.id === id) ?? (CHAPITRES[0] as ChapitreDeNotice);
}
